import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import toast from "react-hot-toast";
import WorkOrderCalendar from "./WorkOrderCalendar";

const Dashboard = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const [searchQuery, setSearchQuery] = useState("");

  const [debouncedQuery, setDebouncedQuery] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(searchQuery), 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const handleLogout = () => {
    logout();
    toast.success("Logged out!", { position: "top-right" });
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6 sm:pr-4 lg:p-8 lg:pr-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4 bg-white p-4 rounded-lg shadow-sm">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
          Work Order Dashboard
        </h1>
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <a
            href="/workorder"
            className="bg-black text-white py-2 px-6 rounded-lg hover:bg-gray-800 transition text-sm font-medium text-center"
          >
            Go to Work Orders
          </a>
          <button
            onClick={handleLogout}
            className="bg-red-600 text-white py-2 px-6 rounded-lg hover:bg-red-700 transition text-sm font-medium"
          >
            Logout
          </button>
        </div>
      </div>

      {/* Calendar - Now fully self-contained */}
      <div className="bg-white p-5 rounded-lg shadow-md">
        <WorkOrderCalendar
          key={debouncedQuery}
          globalSearchQuery={debouncedQuery}
        />
      </div>
    </div>
  );
};

export default Dashboard;
